import { motion } from "framer-motion";
import { Home, Building2, DraftingCompass, KeyRound, Hammer, Calculator, ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/content";

const ICONS = { Home, Building2, DraftingCompass, KeyRound, Hammer, Calculator };

const Services = () => (
  <section id="services" data-testid="services-section" className="relative bg-slate-50 blueprint-grid-fine border-b border-slate-200">
    <span className="absolute top-3 left-4 font-mono text-blueprint/50 select-none" aria-hidden>+</span>
    <span className="absolute bottom-3 right-4 font-mono text-blueprint/50 select-none" aria-hidden>+</span>
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-wrap items-end justify-between gap-6 mb-14"
      >
        <div>
          <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-blueprint-accent mb-6">
            Scope of Work
          </p>
          <h2 className="font-display font-extrabold tracking-tight leading-[1.02] text-4xl md:text-5xl text-prussian">
            What we build.
          </h2>
        </div>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate-400">
          06 Disciplines — One Team
        </p>
      </motion.div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-l border-blueprint-line">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: (i % 3) * 0.1, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`service-card-${i + 1}`}
              className="group relative bg-white border-r border-b border-blueprint-line p-8 md:p-10 hover:bg-prussian transition-colors duration-500"
            >
              <div className="flex items-start justify-between mb-10">
                <Icon
                  size={28}
                  strokeWidth={1.5}
                  className="text-blueprint-accent group-hover:text-white transition-colors duration-500"
                />
                <span className="font-mono text-[10px] tracking-[0.25em] text-slate-400 group-hover:text-blueprint-line transition-colors duration-500">
                  S / 0{i + 1}
                </span>
              </div>
              <h3 className="font-display font-bold tracking-tight text-xl md:text-2xl text-prussian group-hover:text-white transition-colors duration-500 mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-slate-600 group-hover:text-blueprint-line leading-relaxed transition-colors duration-500">
                {s.body}
              </p>
              <ArrowUpRight
                size={18}
                className="absolute bottom-8 right-8 text-blueprint-line opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-[opacity,transform] duration-500"
              />
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Services;
